import { render, staticRenderFns } from "./ChinaUnicomCancelModal.vue?vue&type=template&id=3b77d20f&"
import script from "./ChinaUnicomCancelModal.vue?vue&type=script&lang=js&"
export * from "./ChinaUnicomCancelModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports